module.exports = "/images/vendor/desiigner-svg/svg/logos/48-ore-roma.svg?7dcb57fc7956fea88a69b41cc3fb3eb4";